import { render, staticRenderFns } from "./TransitionBatch.vue?vue&type=template&id=54fe3769&scoped=true"
import script from "./TransitionBatch.vue?vue&type=script&lang=js"
export * from "./TransitionBatch.vue?vue&type=script&lang=js"
import style0 from "./TransitionBatch.vue?vue&type=style&index=0&id=54fe3769&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fe3769",
  null
  
)

export default component.exports